import R from 'ramda'

export const none = 'none'
export const cefr = 'cefr'
export const clb = 'clb'
export const eld = 'eld'
export const nrs = 'nrs'

export const levelFiltersByPreference = {
  [cefr]: 'cefr_levels',
  [clb]: 'clb_levels',
  [eld]: 'eld_levels',
  [nrs]: 'nrs_levels',
  [none]: 'levels',
}

/**
 * Given an array produces a hash where the key is the element and the value is the index.
 */
const sortByElementPositionIn = levels => {
  return levels.reduce((accumulator, currentElement, index) => {
    return R.assoc(currentElement, index, accumulator)
  }, {})
}

export const eslLevels = ['Pre Beg', 'Beg', 'Low Int', 'Int', 'High Int', 'Adv']

export const eslLevelSort = sortByElementPositionIn(eslLevels)

export const clbLevels = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
]

export const cefrLevels = ['A0', 'A1', 'A2', 'B1', 'B2', 'C1', 'c2']

export const eldLevels = [
  'Pre ELD',
  'ELD 1',
  'ELD 2',
  'ELD 3',
  'ELD 4',
  'ELD 5',
  'ELD 6',
]

export const eldLevelSort = sortByElementPositionIn(eldLevels)

export const nrsLevels = ['1', '2', '3', '4', '5', '6', '6+']

export const nrsLevelSort = sortByElementPositionIn(nrsLevels)
